const BANNER_DOMAIN = 'banner'

const BANNER_KEY = {
  DATA: 'data',
  CURRENT: 'current'
}

const BANNER_PATH = {
  DATA: `${BANNER_DOMAIN}.${BANNER_KEY.DATA}`,
  CURRENT: `${BANNER_DOMAIN}.${BANNER_KEY.CURRENT}`
}

const BANNER_STATE = {
  [BANNER_KEY.CURRENT]: null,
  [BANNER_KEY.DATA]: null
}

const BANNER_ACTION = {
  OPEN: 'BANNER_OPEN',
  CLOSE: 'BANNER_CLOSE'
}

/**
 * A mapping of key to modal id.
 * @type {Object}
 */
const BANNER_ID = {
  ERROR: 'BANNER_ERROR',
  SUCCESS: 'BANNER_SUCCESS'
}

export {
  BANNER_ID,
  BANNER_DOMAIN,
  BANNER_KEY,
  BANNER_PATH,
  BANNER_STATE,
  BANNER_ACTION
}
